<template>
    <div :class="classes">
        <slot v-if="label || $slots.label" name="label">
            <label
                v-if="label"
                :for="name"
                class="form-field__label"
                :style="{ width: labelWidth }"
            >
                {{ label }}
                <i v-if="required" class="form-field__required">*</i>
            </label>
        </slot>
        <div class="form-field__control">
            <slot />
        </div>
        <div v-if="fieldError" class="form-field__error">
            {{ errorMessage }}
        </div>
        <div v-else-if="help" class="form-field__help">
            <slot name="help">{{ help }}</slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormField',

    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        inline: {
            type: Boolean,
            default: false
        },
        error: {
            type: Object,
            default: () => ({})
        },
        help: {
            type: String,
            default: ''
        },

        labelWidth: {
            type: String,
            default: 'auto'
        }
    },

    data() {
        const { name, label, required } = this;

        return {
            context: {
                name,
                label,
                required,
                error: this.fieldError
            },
            control: undefined
        };
    },

    provide() {
        return {
            context: this.context,
            registerControl: this.registerControl,
            emitFocus: this.emitFocus,
            emitBlur: this.emitBlur
        };
    },

    computed: {
        classes() {
            return [
                'form-field',
                {
                    'form-field--error': !!this.fieldError,
                    'form-field--required': this.required,
                    'form-field--inline': this.inline
                }
            ];
        },
        fieldError() {
            if (!this.error || !this.error[this.name]) return undefined;

            return this.error[this.name];
        },
        errorMessage() {
            if (!this.error[this.name]) return '';

            return this.error[this.name].join('\n');
        }
    },

    watch: {
        name(value) {
            this.context.name = value;
        },
        label(value) {
            this.context.label = value;
        },
        required(value) {
            this.context.required = value;
        },
        error: {
            deep: true,
            handler() {
                this.context.error = this.fieldError;
            }
        }
    },

    mounted() {
        if (!this.$slots.default) {
            console.warn('FormField: Input required');
        }
    },

    methods: {
        registerControl(component) {
            this.control = component;
        }
    }
};
</script>

<style lang="scss" src="./FormField.scss"></style>
